import clsx from 'clsx';
import { useCallback } from 'react';

import { ColorShadeEditOverlay } from '~components/generic/editor/ColorShadeEditOverlay';
import { IEntityComponentProps } from '~interfaces/props';
import { getTitle } from '~services/entity-helpers';

export interface IColorShadeProps extends IEntityComponentProps {
  isActive: boolean;
  onClick: (x: number) => void;
}

const ColorShade = ({
  isActive,
  onClick,
  data,
  onStopEdit,
  onStartEdit,
  onSave,
  onMoveUp,
  onMoveDown,
  onDelete,
  editing,
  index,
  siblingsLength,
  isEditing,
  context,
  canMove,
  canEdit,
}: IColorShadeProps) => {
  const handleClick = useCallback(() => {
    onClick(index);
  }, [index, onClick]);

  if (!data) {
    return null;
  }

  const _canEdit = isEditing && canEdit && (!context || context === data.id);
  const _canMove = isEditing && canMove;
  const _canMoveUp = _canMove && index > 0;
  const _canMoveDown = _canMove && index < siblingsLength;

  const isLight = data.attributes?.field_light_color || false;
  const hex = (data.attributes?.field_hex || '-').toUpperCase();
  const title = getTitle(data, '-');

  const clsShade = clsx(
    'c-color__shade u-margin-bottom-sm relative c-tooltip c-tooltip--top module-container',
    {
      'c-color__shade--active': isActive,
      'c-color__shade--light': isLight,
    },
    {
      'col col-12': true,
    },
  );

  return (
    <div
      aria-label={title}
      className={clsShade}
      style={{
        backgroundColor: hex,
      }}
      onClick={handleClick}
    >
      {(_canEdit || _canMove) && (
        <ColorShadeEditOverlay
          moduleTitle="Color Shade"
          isEditing={editing || false}
          canEdit={_canEdit}
          canMoveUp={_canMoveUp}
          canMoveDown={_canMoveDown}
          onStopEdit={onStopEdit}
          onStartEdit={onStartEdit}
          onSaveEdit={onSave}
          onMoveUp={onMoveUp}
          onMoveDown={onMoveDown}
          onDelete={onDelete}
        />
      )}
      <i className="u-padding-vertical-xs c-icon-custom c-icon-custom--tick" />
    </div>
  );
};

export default ColorShade;
